import {IError, IOptionsContainer, ISession} from "../networking/Options";
import './PromocodeActivationAlert.css'
import close from "../imgs/close.png";
import React, {useEffect, useState} from "react";
import {openPassport} from "../mainscreen/header/Avatar";
import {CircularProgress} from "@material-ui/core";
import {instance} from "../networking/axios";
import axios, {AxiosResponse} from "axios";
import promo_discount from "../imgs/promo_discount.png";

interface IPromocodeAlertProps {
    promocode: string
    session?: ISession
    onClose: VoidFunction
    onRegister: VoidFunction
    isMobile: boolean
}

interface IPromocodeState {
}

class PromocodeStateLoading implements IPromocodeState {
}

class PromocodeStateActivated implements IPromocodeState {
}

class PromocodeStateError implements IPromocodeState {
    error: string

    constructor(error: string) {
        this.error = error
    }
}

export default function PromocodeActivationAlert(props: IPromocodeAlertProps) {
    return <div className="Promocode_activation_alert_background">
        <img
            className="Promocode_activation_NavBar_Close" src={close}
            onClick={(e) => props.onClose()}
        />
        <PromocodeActivationAlertContent {...props}/>
    </div>
}

function PromocodeActivationAlertContent(props: IPromocodeAlertProps) {
    const [state, setState] = useState<IPromocodeState>(new PromocodeStateLoading())

    function activateCode() {
        setState(new PromocodeStateLoading())

        const promoParams = new URLSearchParams();
        promoParams.append('code', props.promocode);

        const promoRequest = instance.get('/user_app/promo/accept', {params: promoParams});

        promoRequest.then((_: (AxiosResponse | null)) => {
            setState(new PromocodeStateActivated())
        }).catch((error) => {
            const uiMessage = (error.response.data as IError)?.error_details.ui_message
            setState(new PromocodeStateError(uiMessage ?? "Что-то пошло не так"))
        });
    }

    useEffect(() => {
        const sessionParams = new URLSearchParams();
        sessionParams.append('multi_sessions', "1");
        
        const sessionRequest = instance.get('/user_app/sessions/current', {params: sessionParams}).catch((r) => null);
        sessionRequest.then((_) => {
            setTimeout(() => {
                activateCode()
            }, 500)
        })
    }, [])

    if (props.session == null) {
        openPassport()
        return <div/>
    } else {
        if (state instanceof PromocodeStateLoading) {
            return <LoadingAlert code={props.promocode}/>
        } else if (state instanceof PromocodeStateError) {
            return <div className="Promocode_activation_alert_content">
                <p className="Promocode_activation_alert_title">
                    Ошибка
                </p>
                <p className="Promocode_activation_alert_error">{state.error}</p>
                <div className="Promocode_activation_alert_buttons">
                    <button className="Promocode_activation_alert_confirm_button" onClick={() => {
                        activateCode()
                    }}>
                        Попробовать ещё раз
                    </button>
                </div>
            </div>
        } else if (state instanceof PromocodeStateActivated) {
            let isRegistered = props.session?.user.is_registred ?? false
            return <ActivatedAlert
                onClose={isRegistered ? props.onClose : props.onRegister}
                isRegistered={isRegistered}
                code={props.promocode}
                user={props.session?.user.passport.display_name}
                isMobile={props.isMobile}
            />
        } else {
            return <div/>
        }
    }
}

function UnregisteredAlert(props: { code: string }) {
    return <div className="Promocode_activation_alert_content">
        <p className="Promocode_activation_alert_title">
            {`Промокод ${props.code}`}
        </p>
        <p className="Promocode_activation_alert_subtitle">
            Чтобы активировать надо выбрать аккаунт
        </p>
        <div className="Promocode_activation_alert_buttons">
            <button className="Promocode_activation_alert_confirm_button" onClick={() => {
                openPassport()
            }}>
                Выбрать
            </button>
        </div>
    </div>
}

function LoadingAlert(props: { code: string }) {
    return <div className="Promocode_activation_alert_content">
        <p className="Promocode_activation_alert_title">
            {`Активируем промокод ${props.code}...`}
        </p>
        <CircularProgress style={{marginTop: "32px", marginBottom: "12px"}}/>
    </div>
}

function ActivatedAlert(props: { isRegistered: boolean, onClose: Function, code: string, user: string, isMobile: boolean }) {
    let registrationString = props.isMobile ? ". Скачайте приложение, чтобы ей воспользоваться." :  ". Зарегистрируйтесь, чтобы ей воспользоваться."
    let registrationButtonString = props.isMobile ? "Иду качать" : "Иду регистрироваться"
    return <div className="Promocode_activation_alert_content">
        <img style={{width: "94px"}} src={promo_discount}/>
        <p className="Promocode_activation_alert_title">
            {`Промокод ${props.code} активирован для пользователя ${props.user}`}
        </p>
        <p className="Promocode_activation_alert_subtitle">
            {`Теперь у вас есть скидка 50% на первую\nпоездку по тарифу «Фикс» и «Минуты»${props.isRegistered ? "" : registrationString}`}
        </p>
        <div className="Promocode_activation_alert_buttons">
            <button className="Promocode_activation_alert_confirm_button" onClick={() => {
                props.onClose()
            }}>
                {`${props.isRegistered ? "Хорошо" : registrationButtonString}`}
            </button>
        </div>
    </div>
}